var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceCardsIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8511 2.95536C20.8511 4.11806 19.9086 5.06061 18.7459 5.06061C17.5831 5.06061 16.6406 4.11806 16.6406 2.95536C16.6406 1.79265 17.5831 0.850098 18.7459 0.850098C19.9086 0.850098 20.8511 1.79265 20.8511 2.95536Z",
    stroke: "url(#paint0_linear_10059_5260)",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7665 8.11942C19.7969 9.05029 19.7969 10.1259 19.7969 11.3765C19.7969 15.8424 19.7969 18.0754 18.4096 19.4628C17.0222 20.8502 14.7892 20.8502 10.3233 20.8502C5.85734 20.8502 3.62438 20.8502 2.237 19.4628C0.84961 18.0754 0.849609 15.8424 0.849609 11.3765C0.849609 6.91057 0.84961 4.6776 2.237 3.29022C3.62438 1.90283 5.85734 1.90283 10.3233 1.90283C11.5739 1.90283 12.6495 1.90283 13.5803 1.93331",
    stroke: "url(#paint1_linear_10059_5260)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05859 13.4818L7.99847 10.5419C8.40955 10.1308 9.07606 10.1308 9.48711 10.5419L11.1564 12.2111C11.5674 12.6222 12.2339 12.6222 12.645 12.2111L15.5849 9.27124",
    stroke: "url(#paint2_linear_10059_5260)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10059_5260",
    x1: 17.6854,
    y1: 1.10281,
    x2: 19.7655,
    y2: 4.7056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10059_5260",
    x1: 5.55106,
    y1: 3.04004,
    x2: 14.9114,
    y2: 19.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10059_5260",
    x1: 7.67051,
    y1: 9.52395,
    x2: 8.72371,
    y2: 14.0844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceCardsIcons);
export default __webpack_public_path__ + "static/media/DeviceCardsIcons.26f87ea7e4dc52f2ff1fd75e0ac8d287.svg";
export { ForwardRef as ReactComponent };